import { ZdsDivider } from '@zig-design-system/ui-components-react';
import Translation from '../../../../Shared/components/Translation';
import React from 'react';
import FormatUtility, { Formats } from '../../../../Shared/Utility/FormatUtility';
const Contact = ({ title, contact }) => {
    if (contact === null) {
        return null;
    }
    const contactInformation = [
        { label: 'tx_zigrealestate.name', value: contact.name },
        { label: 'tx_zigrealestate.website', value: contact.website, format: Formats.link },
        { label: 'tx_zigrealestate.phone', value: contact.phone, format: Formats.phone },
        { label: 'tx_zigrealestate.email', value: contact.email, format: Formats.email },
    ];
    return (React.createElement("div", null,
        title && (React.createElement("h2", { className: "zds-headline-md" },
            React.createElement(Translation, { item: title }))),
        contactInformation.map(({ label, value, format }, index) => {
            if (value) {
                return (React.createElement("div", { className: "real-estate__property-group", key: index },
                    React.createElement("dl", null,
                        React.createElement("dt", null,
                            React.createElement(Translation, { item: label })),
                        React.createElement("dd", null, FormatUtility.format(value, format)))));
            }
        }),
        title && React.createElement(ZdsDivider, { className: 'zds-margin-y-4 md:zds-margin-y-8' })));
};
export default Contact;
